import React from 'react'

import Text from '@/UI/Text'
import SimpleLink from '@/UI/Link'

import {
  StyledCluster,
  StyledClusterItem
} from './styles'

const Cluster = ({
  name,
  items
}) => {
  return (
    <StyledCluster>
      <Text as="strong" size="sub-desk">{name}</Text>
      {items.map((item, idx) =>(
        <StyledClusterItem key={idx}>

          <SimpleLink {...item.link}>
            <Text size={{
              '@initial': 'p1-mobile',
              '@md': 'p1'
            }}>{item.title}</Text>
          </SimpleLink>
        </StyledClusterItem>
      ))}
    </StyledCluster>
  )
}

export default Cluster
